import React, { useState, useEffect, useRef } from "react";
import { Table, Modal, Spinner, Alert, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";

import PromoteStudentModal from "./PromoteStrudentModal";
import usePagination from "../../../../components/usePagination/usePagination";

export default function PromoteStudent() {
  const alert = useAlert();
  // configgration
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);

  //store data
  const dispatch = useDispatch();
  let campusidget = useSelector((state) => state.campuses.setselectedcampusid);

  //arrays
  const [campuses, setcampuses] = useState(user.campuses || []);
  const [allcampus_classes, setallcampus_classes] = useState([]);
  const [allcampus_classe_sections, setallcampus_classe_sections] = useState(
    []
  );
  const [allsessions, setallsessions] = useState([]);
  const [allstudents, setallstudents] = useState([]);
  const [studentsForFeePromote, setstudentsForFeePromote] = useState([]);
  const [allcheckboxes, setallcheckboxes] = useState([]);
  const [educationType, setEducationType] = useState(1);

  //objects

  //strings
  const [previousselectedcampus, setpreviousselectedcampus] = useState(
    campusidget
  );
  const [selectedcampus, setselectedcampus] = useState("");
  const [selectedclass, setselectedclass] = useState("");
  const [selectedsection, setselectedsection] = useState("");
  const [currentsession, setcurrentsession] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setpostPerPage] = useState(10);
  const [searchtext, setsearchtext] = useState("");

  //booleans
  const [checkallcheckbox, setcheckallcheckbox] = useState(false);
  const [openmodal, setopenmodal] = useState(false);
  const [loader, setloader] = useState(false);

  const [selectedChallans, setSelectedChallans] = useState([]);
  const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const firstTimeLoad = useRef(false);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  useEffect(() => {
    if (!firstTimeLoad.current) {
      firstTimeLoad.current = true;
      getAllSessions();
    }

    if (searchClicked.current) {
      searchClicked.current = false;
      setAllCheckboxes(true);
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedChallans]);

  //functions
  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setcurrentsession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    if (id == "") {
      return alert.error("Please Select Campus");
    }
    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSectionChange = (id) => {
    setSectionId(id);
    fetchStudents(campusId, courseId, classId, id, currentsession);
  };

  const fetchStudents = (
    campusId,
    courseId,
    classId,
    sectionId,
    currentsession
  ) => {
    setloader(true);
    setallstudents([]);
    setstudentsForFeePromote([]);
    let data = {
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      global_section_id: sectionId,
      year_id: currentsession,
    };

    fetch(`${baseUrl}/student_list_to_jump`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            searchClicked.current = true;
            setallstudents([...data.payload]);
            setloader(false);
          } else {
            alert.error("Error Occured");
            setloader(false);
          }
        } else {
          alert.error("Error Occured");
          setloader(false);
        }
      })
      .catch((err) => {
        setloader(false);
        alert.show("Error Occured");
        console.log("students", err);
      });
  };

  //check box work
  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) {
      setAllCheckboxes(false);
    } else {
      setAllCheckboxes(true);
    }
  };

  const setAllCheckboxes = (value) => {
    setmaincheckboxChecked(value);
    if (value) {
      setSelectedChallans([]);
    }

    allstudents.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedChallan(item);
      } else {
        AddSelectedChallan(item);
      }
    });
    console.log(allstudents, "checkbox");
  };

  const checkAllCheckBoxes = () => {
    if (allstudents.length == selectedChallans.length) {
      setmaincheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setmaincheckboxChecked(false);
    }
  };

  const handleChallansCheckBoxClick = (e, index) => {
    allstudents.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;

        if (item.checked) {
          AddSelectedChallan(item);
        } else {
          RemoveSelectedChallan(item);
        }
      }
    });
  };

  const AddSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) => [
      ...prevSelectedChallans,
      item,
    ]);
  };

  const RemoveSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) =>
      prevSelectedChallans.filter((std) => std.id !== item.id)
    );
  };

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  let dataSearch = allstudents.filter((user) => {
    let text = searchtext.toLowerCase();
    return searchtext
      ? user?.name?.toLowerCase().includes(text) ||
          user?.admission_id?.toLowerCase().includes(text)
      : true;
  });

  const count = Math.ceil(dataSearch.length / PER_PAGE);
  const _DATA = usePagination(dataSearch, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {allstudents.length == 0 ? (
          <button
            onClick={() => alert.show("Please Select Some Students")}
            className="btn btn-success button_blue"
          >
            Promote
          </button>
        ) : (
          <button
            onClick={() => setopenmodal(true)}
            className="btn btn-success button_blue"
          >
            Promote
          </button>
        )}
        <br />
        <br />

        <div className="row">
          <div className="form-group col-sm-6 flex-column d-flex">
            <label>
              <b>
                Select Session <span style={{ color: "red" }}>*</span>
              </b>
            </label>
            <select
              onChange={(e) => setcurrentsession(e.target.value)}
              className="form-select form-control"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex flex-column col-sm-6  ">
            <label>
              <b>Search</b>
            </label>
            <input
              onChange={(e) => setsearchtext(e.target.value)}
              id="searchInput"
              className="form-control"
              placeholder="Enter Challan Number or Name or Addmission ID"
            />
          </div>
        </div>
        {currentsession != "" ? (
          <div>
            <div className="row">
              <div className="col-md-3">
                <label>
                  <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  onChange={(e) => onCampusChange(e.target.value)}
                  className="form-select form-control"
                  style={{ backgroundColor: "white", height: 40 }}
                  value={campusId}
                  aria-label="Default select example"
                >
                  <option value="">Select Campus</option>
                  {campuses.map((campus, index) => (
                    <option key={index} value={campus.id}>
                      {campus.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label>
                  <b>Select Course </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  name="course_id"
                  value={courseId}
                  onChange={(e) => onCourseChange(e.target.value)}
                  style={{ backgroundColor: "white", height: 40 }}
                  aria-label="Default select example"
                >
                  <option value="">Select Course</option>
                  {campusCourseData.map((item, index) => (
                    <option key={index} value={item.course?.id}>
                      {item.course?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label>
                  <b>Select Class </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  name="class_id"
                  value={classId}
                  onChange={(e) => onClassChange(e.target.value)}
                  style={{ backgroundColor: "white", height: 40 }}
                  aria-label="Default select example"
                >
                  <option value="">Select Class</option>
                  {courseClassData.map((item, index) => (
                    <option key={index} value={item.class?.id}>
                      {item.class?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label>
                  <b>Select Section </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  name="section_id"
                  value={sectionId}
                  onChange={(e) => onSectionChange(e.target.value)}
                  style={{ backgroundColor: "white" }}
                  aria-label="Default select example"
                >
                  <option value="">Select Section</option>
                  {classSectionData.map((item, index) => (
                    <option key={index} value={item.section?.id}>
                      {item.section?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {loader ? (
              <div className="row justify-content-center">
                <span className="spinner-border"></span>{" "}
              </div>
            ) : (
              <Table responsive className="mt-5">
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Addmission ID</th>
                    <th>Student Class</th>
                    <th>Class Section</th>
                    <th>Monthly Fee</th>
                    <th>
                      <input
                        onClick={(e) => {
                          handleMainCheckboxClick();
                        }}
                        checked={mainCheckBoxChecked}
                        placeholder="Checkbox"
                        type="checkbox"
                        readOnly
                      />
                      <span className="mx-2">Check All</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {_DATA.currentData().map((studentData, index) => (
                    <tr key={studentData.id}>
                      {/* <td style={{ textAlign: "start" }}>{feechallan.name}</td> */}

                      <td
                        title={
                          studentData.name.length > 15 ? studentData.name : null
                        }
                        style={{ textAlign: "start", cursor: "pointer" }}
                      >
                        {studentData.name.length > 15
                          ? studentData.name.substring(0, 12) + "..."
                          : studentData.name}
                      </td>
                      <td
                        title={
                          studentData.father_name.length > 15
                            ? studentData.father_name
                            : null
                        }
                        style={{ textAlign: "start", cursor: "pointer" }}
                      >
                        {studentData.father_name.length > 15
                          ? studentData.father_name.substring(0, 12) + "..."
                          : studentData.father_name}
                      </td>

                      {/* <td style={{ textAlign: "start" }}>{feechallan.father_name}</td> */}
                      <td style={{ textAlign: "start" }}>
                        {studentData.admission_id}
                      </td>
                      <td style={{ textAlign: "start" }}>
                        {studentData.student_class_name}
                      </td>
                      <td style={{ textAlign: "start" }}>
                        {studentData.global_section_name}
                      </td>
                      <td style={{ textAlign: "start" }}>
                        {studentData?.liable_fees[0]?.amount}
                        {/* {feechallan?.liable_fees.map((monthly_fee, index) => (
                          <>{monthly_fee?.amount}</>
                        ))} */}
                      </td>

                      <td style={{ textAlign: "start" }}>
                        <input
                          key={studentData.id}
                          type="checkbox"
                          value={studentData.id}
                          onClick={(e) => {
                            handleChallansCheckBoxClick(e, studentData.id);
                          }}
                          checked={studentData.checked ?? false}
                          readOnly
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <Pagination
              color="primary"
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
            />
          </div>
        ) : null}
      </Paper>

      <PromoteStudentModal
        show={openmodal}
        onHide={setopenmodal}
        students={selectedChallans}
        reload={fetchStudents}
      />
    </div>
  );
}
